import { Typography } from '@mui/material';
import React, { useContext } from 'react';

import TranslationsContext from '../../../../../components/Container/Language';

const ERROR_TRANSLATION_KEYS = {
  ERR_BILLING: 'app:controller:sms:popup:error:balance',
  ERR_RECIPIENT: 'app:controller:sms:popup:error:phone',
  ERR_SENDER: 'app:controller:sms:popup:error:alphaname',
  ERR_LENGTH: 'app:controller:sms:popup:error:message-length',
  ERR_UNKNOWN: 'app:controller:sms:popup:error:unknown',
  ERR_VIBER: 'app:controller:sms:popup:error:viber',
  ERR_RCS: 'app:controller:sms:popup:error:rcs',
  ERROR_VIBER: 'app:controller:sms:popup:error:viber',
  ERROR_VIBER_MESSAGE_REQUIRED: 'app:controller:sms:popup:error:viber:message-required',
  ERROR_VIBER_MESSAGE: 'app:controller:sms:popup:error:viber:message',
  ERROR_VIBER_MESSAGE_LENGTH: 'app:controller:sms:popup:error:viber:message-length',
  ERROR_VIBER_ALPHANAME: 'app:controller:sms:popup:error:viber:alphaname',
  ERROR_VIBER_LIFETIME: 'app:controller:sms:popup:error:viber:lifetime',
  ERROR_RCS: 'app:controller:sms:popup:error:rcs',
  ERROR_RCS_MESSAGE_REQUIRED: 'app:controller:sms:popup:error:rcs:message-required',
  ERROR_RCS_MESSAGE: 'app:controller:sms:popup:error:rcs:message',
  ERROR_RCS_MESSAGE_LENGTH: 'app:controller:sms:popup:error:rcs:message-length',
  ERROR_RCS_ALPHANAME: 'app:controller:sms:popup:error:rcs:alphaname',
  ERROR_RCS_LIFETIME: 'app:controller:sms:popup:error:rcs:lifetime',
  ERROR_RCS_OPERATOR: 'app:controller:sms:popup:error:rcs:operator',
  ERROR_VIBER_IMAGE_NOT_FOUND: 'app:controller:sms:popup:error:image',
  ERROR_RCS_IMAGE_NOT_FOUND: 'app:controller:sms:popup:error:image',
  ERROR_VIBER_IMAGE_REQUIRED: 'app:controller:sms:popup:error:image',
  ERROR_RCS_IMAGE_REQUIRED: 'app:controller:sms:popup:error:image',
  ERROR_VIBER_URL_FORMAT: 'app:controller:sms:popup:error:url',
  ERROR_RCS_URL_FORMAT: 'app:controller:sms:popup:error:url',
  ERROR_VIBER_URL_REQUIRED: 'app:controller:sms:popup:error:url',
  ERROR_RCS_URL_REQUIRED: 'app:controller:sms:popup:error:url',
  ERROR_VIBER_BUTTON: 'app:controller:sms:popup:error:button',
  ERROR_RCS_BUTTON: 'app:controller:sms:popup:error:button',
  ERROR_VIBER_CAROUSEL_BUTTON: 'app:controller:sms:popup:error:carousel-button',
  ERROR_VIBER_CAROUSEL_BUTTON2: 'app:controller:sms:popup:error:carousel-button2',
  ERROR_VIBER_CAROUSEL_CAPTION_LENGTH: 'app:controller:sms:popup:error:carousel-caption-length',
  ERROR_VIBER_CAROUSEL_CAPTION_REQUIRED: 'app:controller:sms:popup:error:carousel-caption',
  ERROR_VIBER_CAROUSEL_IMAGE_LENGTH: 'app:controller:sms:popup:error:carousel-image-length',
  ERROR_VIBER_CAROUSEL_TOTAL: 'app:controller:sms:popup:error:carousel-total',
  ERROR_VIBER_CAROUSEL_REQUIRED: 'app:controller:sms:popup:error:carousel',
  ERROR_VIBER_SURVEY_REQUIRED: 'app:controller:sms:popup:error:survey',
  ERROR_VIBER_SURVEY_TOTAL: 'app:controller:sms:popup:error:survey-total',
  ERROR_VIBER_SURVEY_OPTION: 'app:controller:sms:popup:error:survey-option',
  ERROR_VIBER_SURVEY_OPTION_LENGTH: 'app:controller:sms:popup:error:survey-option',
  ERROR_ACCESS_DENIED: 'app:controller:sms:popup:error:access-denied',
  ERROR_DUPLICATE: 'app:controller:sms:popup:error:duplicate',
  ERROR_ADDRESSBOOK_REQUIRED: 'app:controller:sms:popup:error:recipients',
  ERROR_ADDRESSBOOK_NOT_FOUND: 'app:controller:sms:popup:error:recipients-exist',
  ERROR_ALPHANAME: 'app:controller:sms:popup:error:alphaname',
  ERROR_ALPHANAME_FORMAT: 'app:controller:sms:popup:error:alphaname-format',
  ERROR_ALPHANAME_LENGTH: 'app:controller:sms:popup:error:alphaname-length',
  ERROR_BALANCE: 'app:controller:sms:popup:error:balance',
  ERROR_CAMPAIGN_NAME: 'app:controller:sms:popup:error:campaign-name',
  ERROR_CAMPAIGN_FINISH: 'app:controller:sms:popup:error:campaign-finish',
  ERROR_FLASH_CONCATENATED: 'app:controller:sms:popup:error:flash-concatenated',
  ERROR_MESSAGE: 'app:controller:sms:popup:error:message',
  ERROR_MESSAGE_EMPTY: 'app:controller:sms:popup:error:message-empty',
  ERROR_MESSAGE_LENGTH: 'app:controller:sms:popup:error:message-length',
  ERROR_PHONE: 'app:controller:sms:popup:error:phone',
  ERROR_PHONELIST: 'app:controller:sms:popup:error:phonelist',
  ERROR_UNKNOWN: 'app:controller:sms:popup:error:unknown',
  ERROR_EMPTY: 'app:controller:sms:popup:error:phone-exist',
  ERROR_START: 'app:controller:sms:popup:error:start',
  ERROR_SMS_ALPHANAME: 'app:controller:sms:popup:error:alphaname',
  ERROR_SMS_MESSAGE: 'app:controller:sms:popup:error:message',
  ERROR_SMS_MESSAGE_LENGTH: 'app:controller:sms:popup:error:message-length',
  ERROR_SMS_MESSAGE_REQUIRED: 'app:controller:sms:popup:error:phonelist',
};

const resolveErrorText = (code, value, t) => {
  const translationKey = ERROR_TRANSLATION_KEYS[code];
  if (translationKey) {
    const translated = t(translationKey);
    if (translated) {
      return translated;
    }
  }

  return value || code;
};

const SmsResultErrors = ({ errors }) => {
  const { t } = useContext(TranslationsContext);

  if (!errors) {
    return null;
  }

  if (!Array.isArray(errors) && typeof errors === 'object') {
    return (
      <>
        {Object.entries(errors).map(([code, value]) => (
          <Typography color="error" key={code}>
            {resolveErrorText(code, value, t)}
          </Typography>
        ))}
      </>
    );
  }

  const list = Array.isArray(errors) ? errors : [];

  return (
    <>
      {list.map((code) => {
        const translationKey = ERROR_TRANSLATION_KEYS[code];
        const text = translationKey ? t(translationKey) : null;
        if (!text) {
          return null;
        }

        return (
          <Typography color="error" key={code}>
            {text}
          </Typography>
        );
      })}
    </>
  );
};

export default SmsResultErrors;
